<template>
  <XBaseEmojiReaction
    :value="value"
    :dataEmoji="emojiName"
    v-bind="$props"
    v-on="$listeners"
  >
    <template slot="hint">
      <slot name="hint" />
    </template>
    <template slot="optional">
      {{ $t('common.formFields.fields.optional') }}
    </template>
    <template slot="extra">
      <slot name="extra" />
    </template>
  </XBaseEmojiReaction>
</template>

<script>
import XBaseEmojiReaction from '@common/components/BaseEmojiReaction'

const INHERIT_PROPS = XBaseEmojiReaction.props

export default {
  components: {
    XBaseEmojiReaction
  },

  props: {
    ...INHERIT_PROPS,

    withName: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    emojiName (emoji) {
      return this.withName
        ? this.$t('common.emojiReactions.' + emoji)
        : null
    }
  }
}
</script>
